import './index.scss';
import applyCountdown from 'utils/countdown';

export default class AccountLimitFreeModal {
  countdownV1Animation() {
    const fullTime = 10;

    const $circle = $('#out-circle');
    const $counterText = $('#counter-text');
    $counterText.text(fullTime);

    let remainingTime = fullTime;

    const circumference = 2 * Math.PI * $circle.attr('r');
    $circle.css({
      'stroke-dasharray': circumference,
      'stroke-dashoffset': 0,
      transform: 'rotate(-90deg)',
      'transform-origin': '50% 50%'
    });

    setTimeout(() => {
      const interval = setInterval(function () {
        remainingTime--;
        $counterText.text(remainingTime);

        const dashoffset =
          circumference * ((fullTime - remainingTime) / fullTime) * 1.5;
        $circle.css('stroke-dashoffset', dashoffset);

        const adjustedDashoffset = Math.min(dashoffset, circumference);
        $circle.css('stroke-dashoffset', adjustedDashoffset);

        if (remainingTime <= 0) {
          clearInterval(interval);
        }
      }, 80);
    }, 1000);
  }

  countdownV2Animation() {
    const fullTime = 24 * 60 * 60;
    const now = new Date();
    const secondsSinceMidnight =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    const remainingTime = fullTime - secondsSinceMidnight;
    const $circle = $('#out-circle');

    const circumference = 2 * Math.PI * $circle.attr('r');
    const initialOffset = circumference * (secondsSinceMidnight / fullTime);
    $circle.css({
      'stroke-dasharray': circumference,
      'stroke-dashoffset': initialOffset,
      transform: 'rotate(-90deg)',
      'transform-origin': '50% 50%'
    });

    setTimeout(() => {
      let currentRemainingTime = remainingTime;
      const interval = setInterval(function () {
        currentRemainingTime--;

        const dashoffset =
          circumference * ((fullTime - currentRemainingTime) / fullTime);
        $circle.css('stroke-dashoffset', dashoffset);

        if (currentRemainingTime <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    });
  }

  showTimeLeft() {
    applyCountdown({
      selector: '.js-account-limit-questions-modal .limit-countdown',
      template: '%H:%M:%S'
    });
    applyCountdown({
      selector: '.js-account-limit-questions-modal .subtitle-limit-countdown',
      template: '%H:%M:%S'
    });
  }

  selectVersion() {
    const modalLimitation = gon.flags?.modal_limitation;

    if (modalLimitation) {
      if (modalLimitation.showV2) {
        this.countdownV2Animation();
      } else {
        this.countdownV1Animation();
      }
    }
  }

  load() {
    this.showTimeLeft();
    this.selectVersion();
  }
}
